(function(){
  document.addEventListener('click', function(e){
    var b = e.target.closest('.qty button');
    if (b) {
      var i = b.parentElement.querySelector('input');
      var min = parseInt(i.getAttribute('min') || '0', 10);
      var step = b.getAttribute('data-step') === '1' ? 1 : -1;
      i.value = Math.max(min, (parseInt(i.value, 10) || 0) + step);
      return;
    }
    var t = e.target.closest('[data-thumb]');
    if (t) {
      e.preventDefault();
      var m = document.querySelector('.gmain img');
      if (m) { m.removeAttribute('srcset'); m.src = t.getAttribute('data-thumb'); }
      document.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.toggle('on', x === t); });
    }
  });
  var sel = document.querySelector('[data-variant-select]');
  if (sel) {
    sel.addEventListener('change', function(){
      var o = sel.options[sel.selectedIndex];
      document.querySelectorAll('[data-price]:not(option)').forEach(function(p){ p.textContent = o.getAttribute('data-price'); });
      var vi = o.getAttribute('data-img'), gm = document.querySelector('.gmain img');
      if (vi && gm) { gm.removeAttribute('srcset'); gm.src = vi; document.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.toggle('on', x.getAttribute('data-thumb') === vi); }); }
      var ok = o.getAttribute('data-available') === 'true';
      document.querySelectorAll('[data-buy]').forEach(function(btn){ btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute('data-label') : 'Изчерпан'; });
      document.querySelectorAll('[data-stock]').forEach(function(s){ s.textContent = ok ? 'В наличност' : 'Изчерпан'; s.classList.toggle('out', !ok); });
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState({}, '', u); }
    });
  }
  var hdr = document.getElementById('shopify-section-header') || document.querySelector('.hdr'), topbar = document.querySelector('.top'), mt = document.getElementById('mt'), lastY = window.pageYOffset, tick = false;
  if (hdr) {
    var fixTop = function(){ hdr.style.top = topbar ? (-topbar.offsetHeight) + 'px' : '0px'; };
    fixTop(); window.addEventListener('resize', fixTop);
    window.addEventListener('scroll', function(){
      if (tick) return; tick = true;
      requestAnimationFrame(function(){
        var y = window.pageYOffset;
        if (mt && mt.checked) { hdr.classList.remove('hdr-hide'); }
        else if (y > lastY + 4 && y > 160) { hdr.classList.add('hdr-hide'); }
        else if (y < lastY - 4 || y <= 160) { hdr.classList.remove('hdr-hide'); }
        lastY = y; tick = false;
      });
    }, { passive: true });
  }
})();
